<div
  class="box-promo-tag"
  [reactComponent]="promoTagComponent"
  *ngIf="tagOptions"
  [props]="tagOptions"
></div>
<figure class="checkout-suggestion-banner-card-image">
  <img [src]="imageSrc" [alt]="campaignName" />
</figure>
<button
  box-button
  size="small"
  theme="primary"
  class="checkout-suggestion-banner-card-btn"
  (click)="onBannerSelect($event)"
>
  {{ 'i_want_it' | translate }}!
</button>
